import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontBarlow, fontBarlowSemiCondensed } from "@product/scmp-sdk";

import { AuthorName } from "~/components/author/author-name";

export const Container = styled.div``;

export const AuthorNameContainerLabel = styled.span`
  margin-block-end: 6px;

  font-weight: 700;
`;

type AuthorNameContainerProps = {
  $isMultipleAuthor: boolean;
};
export const AuthorNameContainer = styled.div<AuthorNameContainerProps>`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;

  color: #222222;
  font-weight: normal;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  line-height: normal;
  letter-spacing: 0.7px;
  text-transform: uppercase;

  ${props => {
    if (props.$isMultipleAuthor) {
      return css`
        ${AuthorNameContainerLabel} {
          inline-size: 100%;
        }
      `;
    }
  }}

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 18px;
  }

  ${props => props.theme.breakpoints.up("desktop")} {
    font-size: 16px;
    letter-spacing: 0.8px;
  }
`;

export const StyledAuthorName = styled(AuthorName)`
  position: relative;

  margin-block-end: 6px;
  padding-inline: 8px;

  color: #222222;
  font-weight: 400;
  letter-spacing: 0.8px;
  white-space: nowrap;
  text-transform: uppercase;
  &::after {
    position: absolute;
    inset-block-start: 0;
    inset-inline-end: 0;
    content: "";

    inline-size: 1px;
    block-size: 100%;

    background-color: #000000;

    transform: rotate(15deg);
  }
  &:last-child {
    padding-inline-end: 0;
    &::after {
      display: none;
    }
  }
`;

export const ArticleDateContainer = styled.div`
  margin-block-end: 40px;

  color: #a1a1a1;
  font-weight: 600;
  font-size: 14px;
  font-family: ${fontBarlow};
  font-style: normal;
  line-height: normal;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 48px;
  }
`;
